import { IPhoneSchema } from '@cian/api-models/offer-card/v1/get-offer-data';

export function formatNumber(phone: IPhoneSchema) {
  if (!phone.countryCode || !phone.number) {
    return null;
  }

  return `${phone.countryCode} ${phone.number.replace(/(\d{3})(\d{3})(\d{2})(\d{2})/, '$1 $2-$3-$4')}`;
}
